const DESIGN_SELECTORS = {
  content: "#design-colors-content",
  container: "#product-design-selector",
  element: ".swatch-design-element",
  loading: "design-loading",
  class: ".product-id",
  variants: {
    container: ".swatch.selectors",
    variant: ".swatch-element",
    active: ".active",
  }
}

document.addEventListener("Section:Loaded", async event => {
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;

  if (sectionType === 'product-alt' || sectionType === 'product_page') {
    initDesignSwatches();
  }
});

const initDesignSwatches = () => {
  const selector = document.querySelector(DESIGN_SELECTORS.container);
  if (selector) {
    selector.querySelectorAll(DESIGN_SELECTORS.element).forEach(selectDesign);
  }
}

const selectDesign = element => {
  element.addEventListener('click', async event => {
    event.preventDefault();
    const containerClass = DESIGN_SELECTORS.class;

    const parent = event.target.closest(containerClass).parentElement;
    parent.classList.add(DESIGN_SELECTORS.loading)
    const isQuickProduct = parent.classList.contains('modal-content');

    let url = element.getAttribute('href');
    if (isQuickProduct) url += '?view=quick';

    const response = await fetch(url);
    const html = document.createElement('html');
    html.innerHTML = await response.text();

    let container = parent.querySelector(containerClass);
    const variants = getVariants(container);
    container.outerHTML = html.querySelector(containerClass).outerHTML;

    container = parent.querySelector(containerClass);

    if (isQuickProduct) {
      sectionObserver();
      //imageObserver();
      Swatches(container);
      if (container.getAttribute('data-cart') == 'true') {
        Cart(container);
      }
    } else {
      ProductOptions(container);
      Product(container);
      //imageObserver();
      initDesignSwatches();
      const parts = window.location.pathname.split('/products/');
      window.history.pushState({}, null, `${parts[0]}${url}`);
    }

    setVariants(parent, variants);

    setTimeout(() => {
      if (Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    }, 300);
    parent.classList.remove(DESIGN_SELECTORS.loading);
    parent.style.display = 'none';
    parent.offsetHeight;
    parent.style.display = '';
  })
}

const getVariants = (parent) => {
  return [...parent.querySelectorAll(DESIGN_SELECTORS.variants.container)].map(container => {
    return container.querySelector(`${DESIGN_SELECTORS.variants.variant}${DESIGN_SELECTORS.variants.active}`).dataset.value
  })
}

const setVariants = (parent, variants) => {
  parent.querySelectorAll(DESIGN_SELECTORS.variants.container).forEach((container, index) => {
    let activeVariant = container.querySelector(`${DESIGN_SELECTORS.variants.variant}`);

    if (variants[index]) {
      activeVariant = container.querySelector(`${DESIGN_SELECTORS.variants.variant}[data-value='${variants[index]}']`);
    }

    if (activeVariant) {
      if (index === 0) {
        setTimeout(() => { activeVariant.querySelector('label').click() }, 0)
      } else {
        activeVariant.querySelector('label').click();
      }
    }
  })
}

const mediaQuery = window.matchMedia('(max-width: 940px)')

if (mediaQuery.matches) {
  const acc = document.querySelectorAll('.arrow');

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.classList.toggle("is-open");
      this.parentElement.classList.toggle('active');
    });
  }
}


// megamenu

megamenuList(document.querySelectorAll('.mega-first-level-list'));
megamenuList(document.querySelectorAll('.mega-second-level-list'));
megamenuList(document.querySelectorAll('.mega-third-level-list'));

function megamenuList(arraySelector) {
  arraySelector.forEach((currentElement) => {
    currentElement.addEventListener("mouseenter", (event) => {
      const mediaQuery = window.matchMedia('(min-width: 940px)');
      if(mediaQuery.matches) {
        [...event.currentTarget.parentElement.children].forEach(sib => sib.classList.remove('active__item'));
        event.currentTarget.classList.add('active__item');
      }
    });
  });
}

var mega_menu_wrapper = document.querySelectorAll('.mega-menu-wrapper.for-desktop');

mega_menu_wrapper.forEach((currentElement) => {
  currentElement.addEventListener("mouseleave", (ev) => {
    [...ev.currentTarget.children[0].children].forEach((sib, i) => {
      if (i == 0) {
        sib.classList.add('active__item');
      } else {
        sib.classList.remove('active__item');
        [...sib.children[1].children].forEach((sib2, i) => {
          if (i == 0) {
            sib2.classList.add('active__item');
          } else {
            sib2.classList.remove('active__item');
            [...sib2.children[1].children].forEach((sib_2, k) => { k == 0 ? sib_2.classList.add('active__item') : sib_2.classList.remove('active__item'); });
          };
        });
      }
    });

    [...ev.currentTarget.children[0].children[0].children[1].children].forEach((sib2, i) => {
      if (i == 0) {
        sib2.classList.add('active__item');
      } else {
        sib2.classList.remove('active__item');
        [...sib2.children[1].children].forEach((sib_2, j) => { j == 0 ? sib_2.classList.add('active__item') : sib_2.classList.remove('active__item'); });
      }
    });

    [...ev.currentTarget.children[0].children[0].children[1].children[0].children[1].children].forEach((sib3, i) => {
      i == 0 ? sib3.classList.add('active__item') : sib3.classList.remove('active__item');
    });
  });
});
